import { useManagerTeam } from '@/common/hooks/useManagerTeam'
import { Button } from '@/common/components/button'
import * as styles from './TeamMembers.css'

function statusClassName(status: string) {
  switch (status) {
    case 'submitted':
      return styles.statusSubmitted
    case 'approved':
      return styles.statusApproved
    case 'rejected':
      return styles.statusRejected
    case 'none':
      return styles.statusNone
    default:
      return styles.statusDraft
  }
}

export function TeamMembers() {
  const { data, isLoading, error, refetch } = useManagerTeam()

  if (isLoading) {
    return (
      <div className={styles.page}>
        <div className={styles.loading}>Loading team...</div>
      </div>
    )
  }

  if (error) {
    return (
      <div className={styles.page}>
        <div className={styles.errorBox}>
          <span>Failed to load team: {error.message}</span>
          <Button variant="outline" size="sm" onClick={() => refetch()}>
            Retry
          </Button>
        </div>
      </div>
    )
  }

  return (
    <div className={styles.page}>
      <h1 className={styles.title}>Team members</h1>

      {data && data.length > 0 ? (
        <table className={styles.table}>
          <thead>
            <tr>
              <th className={styles.th}>Name</th>
              <th className={styles.th}>Email</th>
              <th className={styles.th}>Title</th>
              <th className={styles.th}>Department</th>
              <th className={styles.th}>Timesheet</th>
            </tr>
          </thead>
          <tbody>
            {data.map((member) => (
              <tr key={member.employee_id}>
                <td className={styles.td}>
                  {member.first_name} {member.last_name}
                </td>
                <td className={styles.tdSecondary}>{member.email}</td>
                <td className={styles.tdSecondary}>{member.job_title ?? '—'}</td>
                <td className={styles.tdSecondary}>{member.department ?? '—'}</td>
                <td className={styles.td}>
                  <span className={statusClassName(member.current_timesheet_status)}>
                    {member.current_timesheet_status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div className={styles.emptyState}>
          No team members found
        </div>
      )}
    </div>
  )
}
